import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, createRef, } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import common from '@mui/material/colors/common';
import grey from '@mui/material/colors/grey';
import BrokenImage from '@mui/icons-material/BrokenImage';
export class Image extends Component {
    image;
    constructor(props) {
        super(props);
        this.state = {
            imageError: false,
            imageLoaded: false,
            src: this.props.src,
        };
        this.image = createRef();
    }
    static getDerivedStateFromProps(props, state) {
        if (state.src !== props.src) {
            return {
                imageError: false,
                imageLoaded: false,
                src: props.src,
            };
        }
        return null;
    }
    componentDidMount() {
        const img = this.image.current;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (img && img.complete) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            if (img.naturalWidth === 0) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.handleImageError();
            }
            else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.handleLoadImage();
            }
        }
    }
    getStyles() {
        const { animationDuration, aspectRatio, cover, color, imageStyle, disableTransition, iconContainerStyle, style, } = this.props;
        const imageTransition = !disableTransition && {
            opacity: this.state.imageLoaded ? 1 : 0,
            filterBrightness: this.state.imageLoaded ? 100 : 0,
            filterSaturate: this.state.imageLoaded ? 100 : 20,
            transition: `
        filterBrightness ${(animationDuration || 1) * 0.75}ms cubic-bezier(0.4, 0.0, 0.2, 1),
        filterSaturate ${animationDuration}ms cubic-bezier(0.4, 0.0, 0.2, 1),
        opacity ${(animationDuration || 1) / 2}ms cubic-bezier(0.4, 0.0, 0.2, 1)`,
        };
        return {
            root: {
                backgroundColor: color,
                paddingTop: `calc(1 / ${aspectRatio} * 100%)`,
                position: 'relative',
                ...style,
            },
            image: {
                width: '100%',
                height: '100%',
                position: 'absolute',
                objectFit: cover ? 'cover' : 'inherit',
                top: 0,
                left: 0,
                ...imageTransition,
                ...imageStyle,
            },
            iconContainer: {
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                pointerEvents: 'none',
                ...iconContainerStyle,
            },
        };
    }
    handleLoadImage = e => {
        this.setState({ imageLoaded: true, imageError: false });
        if (this.props.onLoad) {
            this.props.onLoad(e);
        }
    };
    handleImageError = e => {
        if (this.props.src) {
            this.setState({ imageError: true });
            if (this.props.onError) {
                this.props.onError(e);
            }
        }
    };
    render() {
        const styles = this.getStyles();
        const { disableError, disableSpinner, errorIcon, loading, onClick, ...image } = this.props;
        // delete unrecognizable DOM props
        delete image.disableTransition;
        delete image.animationDuration;
        delete image.aspectRatio;
        delete image.imageStyle;
        return (_jsxs("div", { style: styles.root, onClick: onClick, children: [image.src && (_jsx("img", { ...image, ref: this.image, style: styles.image, onLoad: this.handleLoadImage, onError: this.handleImageError }, void 0)), _jsxs("div", { style: styles.iconContainer, children: [!disableSpinner &&
                            !this.state.imageLoaded &&
                            !this.state.imageError &&
                            loading, !disableError && this.state.imageError && errorIcon] }, void 0)] }, void 0));
    }
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Image.defaultProps = {
    animationDuration: 3000,
    aspectRatio: 1,
    color: common.white,
    disableError: false,
    disableSpinner: false,
    disableTransition: false,
    errorIcon: (_jsx(BrokenImage, { style: { width: 48, height: 48, color: grey[300] } }, void 0)),
    loading: _jsx(CircularProgress, { size: 48 }, void 0),
};
//# sourceMappingURL=Image.js.map